var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#DDD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/edit-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.62993 1.8L2.52493 6.145C2.36993 6.31 2.21993 6.635 2.18993 6.86L2.00493 8.48C1.93993 9.065 2.35993 9.465 2.93993 9.365L4.54993 9.09C4.77493 9.05 5.08993 8.885 5.24493 8.715L9.34993 4.37C10.0599 3.62 10.3799 2.765 9.27493 1.72C8.17493 0.685002 7.33993 1.05 6.62993 1.8Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.94507 2.525C6.16007 3.905 7.28007 4.96 8.67007 5.1",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.5 11H10.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.66e99ed714b825af83e65eb9a2da5c1a.svg";
export { ForwardRef as ReactComponent };